import { EventEmitter, Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Observable } from 'rxjs';
import { BASE_LMSA_URL } from '../../app.constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CodedValueService {

  navchange: EventEmitter<number> = new EventEmitter();

  private codedValueURL = BASE_LMSA_URL + 'api/0.9/json/merchant/codedvalues/map';
  private userAccessUrl = BASE_LMSA_URL + 'api/0.9/json/user/uars/map';
  private moduleListUrl = BASE_LMSA_URL + 'api/0.9/json/merchant/merchantmodules/map';
  private userSettingUrl = BASE_LMSA_URL + 'api/0.9/json/merchant/merchantsettings/map';

  constructor(private authService: AuthService, private storage: StorageMap,) { }

  loadCodedValue() {
    const headers = { "ngBrowserVersion": "true" };
    const factory = () => ({ method: 'GET', headers });
    const options = { factory }

    return new Observable((observable) => {
      if (!this.authService.userDigestAuth) {
        this.authService.checkForAuth();
      }
      if (!this.authService.userDigestAuth) {
        observable.error('not authenticated')
      }
      this.authService.userDigestAuth.fetch(this.codedValueURL, options)
        .then(resp => resp.json())
        .then(data => {
          if (data.status == 'success') {
            this.storage.set('codedvalue', data.data).subscribe(() => {
            });
          }
          observable.next(data);
        })
        .catch(e => {
          observable.error(e);
        });
    });
  }

  loadUsrList() {
    const headers = { "ngBrowserVersion": "true" };
    const factory = () => ({ method: 'GET', headers });
    const options = { factory }

    return new Observable((observable) => {
      if (!this.authService.userDigestAuth) {
        this.authService.checkForAuth();
      }
      if (!this.authService.userDigestAuth) {
        observable.error('not authenticated')
      }
      this.authService.userDigestAuth.fetch(this.userAccessUrl, options)
        .then(resp => resp.json())
        .then(data => {
          if (data.status == 'success') {
            this.storage.set('uarlist', data.data).subscribe(() => {
            });
          }
          observable.next(data);
          this.navchange.emit(data);
        })
        .catch(e => {
          observable.error(e);
        });
    });
  }

  getNavChangeEmitter() {
    return this.navchange;
  }

  loadModuleList() {
    const headers = { "ngBrowserVersion": "true" };
    const factory = () => ({ method: 'GET', headers });
    const options = { factory }

    return new Observable((observable) => {
      if (!this.authService.userDigestAuth) {
        this.authService.checkForAuth();
      }
      if (!this.authService.userDigestAuth) {
        observable.error('not authenticated')
      }
      this.authService.userDigestAuth.fetch(this.moduleListUrl, options)
        .then(resp => resp.json())
        .then(data => {
          if (data.status == 'success') {
            this.storage.set('moduleslist', data.data).subscribe(() => {
            });
          }
          observable.next(data);
        })
        .catch(e => {
          observable.error(e);
        });
    });
  }

  loadSettingsList() {
    const headers = { "ngBrowserVersion": "true" };
    const factory = () => ({ method: 'GET', headers });
    const options = { factory }

    return new Observable((observable) => {
      if (!this.authService.userDigestAuth) {
        this.authService.checkForAuth();
      }
      if (!this.authService.userDigestAuth) {
        observable.error('not authenticated')
      }
      this.authService.userDigestAuth.fetch(this.userSettingUrl, options)
        .then(resp => resp.json())
        .then(data => {
          if (data.status == 'success') {
            this.storage.set('settingslist', data.data).subscribe(() => {
            });
          }
          observable.next(data);
        })
        .catch(e => {
          observable.error(e);
        });
    });
  }

  getModuleValue() {
    return this.storage.get('moduleslist');
  }

  getusrValue() {
    return this.storage.get('uarlist');
  }

  getusrSettingValue() {
    return this.storage.get('settingslist');
  }

  getCodedValue() {
    return this.storage.get('codedvalue');
  }

  getUserDetails(){
    return this.storage.get('userDetails');
  }
}
